import { render } from "./InventoryTable.vue?vue&type=template&id=5c4a179e"
import script from "./InventoryTable.vue?vue&type=script&lang=js"
export * from "./InventoryTable.vue?vue&type=script&lang=js"

import "./InventoryTable.vue?vue&type=style&index=0&id=5c4a179e&lang=css"

import exportComponent from "C:\\VueProjects\\AdminXhantaeShopify\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__